import React, { useState } from 'react';
import { OverlayTrigger, Tooltip, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCheckDouble, faEllipsisV, faReply, faTrash, faFlag } from '@fortawesome/free-solid-svg-icons';
import UserAvatar from './UserAvatar';
import { formatTimestamp } from '../../utils/dateUtils';
import './MessageBubble.css';

function MessageBubble({ message, isOwn, showAvatar, onReply, onDelete, onReport }) {
  const { content, senderName, senderPhotoUrl, createdAt, status } = message;
  const [showActions, setShowActions] = useState(false);

  const renderStatusIcon = () => {
    if (!isOwn) return null;

    switch (status) {
      case 'read':
        return (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Read</Tooltip>}
          >
            <span className="message-status text-primary">
              <FontAwesomeIcon icon={faCheckDouble} />
            </span>
          </OverlayTrigger>
        );
      case 'delivered':
        return (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Delivered</Tooltip>}
          >
            <span className="message-status text-muted">
              <FontAwesomeIcon icon={faCheckDouble} />
            </span>
          </OverlayTrigger>
        );
      case 'sent':
        return (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Sent</Tooltip>}
          >
            <span className="message-status text-muted">
              <FontAwesomeIcon icon={faCheck} />
            </span>
          </OverlayTrigger>
        );
      default:
        return null;
    }
  };

  return (
    <div 
      className={`message-bubble-wrapper ${isOwn ? 'own' : 'other'}`}
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
    >
      {!isOwn && (
        <div className="message-avatar">
          {showAvatar ? (
            <UserAvatar
              photoUrl={senderPhotoUrl}
              displayName={senderName}
              size="sm"
            />
          ) : (
            <div style={{ width: '32px' }} />
          )}
        </div>
      )}

      <div className="message-bubble-content">
        {!isOwn && showAvatar && (
          <div className="message-sender-name">{senderName}</div>
        )}
        <div className={`message-bubble ${isOwn ? 'own' : 'other'}`}>
          <div className="message-text">{content}</div>
          
          {/* Message actions dropdown */}
          {showActions && (
            <div className="message-actions">
              <Dropdown align={isOwn ? 'end' : 'start'}>
                <Dropdown.Toggle 
                  variant="link" 
                  size="sm" 
                  className="message-actions-toggle"
                  id={`message-actions-${message.messageId}`}
                >
                  <FontAwesomeIcon icon={faEllipsisV} />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {onReply && (
                    <>
                      <Dropdown.Item onClick={() => onReply(message, 'sender')}>
                        <FontAwesomeIcon icon={faReply} className="me-2" />
                        Reply to sender
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => onReply(message, 'all')}>
                        <FontAwesomeIcon icon={faReply} className="me-2" />
                        Reply to all
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => onReply(message, 'custom')}>
                        <FontAwesomeIcon icon={faReply} className="me-2" />
                        Reply with custom recipients
                      </Dropdown.Item>
                      <Dropdown.Divider />
                    </>
                  )}
                  {!isOwn && onReport && (
                    <>
                      <Dropdown.Item 
                        onClick={() => onReport(message)}
                        className="text-warning"
                      >
                        <FontAwesomeIcon icon={faFlag} className="me-2" />
                        Report message
                      </Dropdown.Item>
                      <Dropdown.Divider />
                    </>
                  )}
                  {onDelete && (
                    <Dropdown.Item 
                      onClick={() => onDelete(message)}
                      className="text-danger"
                    >
                      <FontAwesomeIcon icon={faTrash} className="me-2" />
                      Delete for me
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
        </div>
        <div className="message-metadata">
          <span className="message-time">{formatTimestamp(createdAt)}</span>
          {renderStatusIcon()}
        </div>
      </div>
    </div>
  );
}

export default MessageBubble;
